import React from 'react';

import { Carousel, Grid } from '_utils/components/Corporate';

const ItemWrapper = ({ carouselEnabled, children }) => {
  if (!carouselEnabled) {
    return (
      <Grid.Row config={{ gutters: ['left', 'right'] }} mt={{ xs: 1, md: 3 }}>
        {children}
      </Grid.Row>
    );
  }

  return (
    <Grid.Row config={{ gutters: ['left', 'right'] }} mt={{ xs: 1, md: 3 }}>
      <Grid.Item config={{ col: 12, gutters: ['left', 'right'] }}>
        <Carousel flickityOptions={{ groupCells: true, cellAlign: 'left' }}>{children}</Carousel>
      </Grid.Item>
    </Grid.Row>
  );
};

export default ItemWrapper;
